module.exports = __webpack_public_path__ + "img/category.235df9b1.png";